import React, {Component} from "react";
import {
    Alert,
    Linking,
    PermissionsAndroid, Platform, Image, Dimensions,
    ToastAndroid, Share,
    Clipboard,
    I18nManager
} from "react-native";

import i18n from '../I18n/i18n.js';
import axios from "axios";
import store from "../redux/store";
import {typeExport} from "../redux/store/type";


export class RequestApi extends Component {

    static requestAddComment(params, funcSuccess, funcError, shahrvandFlag) {
        let {token} = store.getState().reducerSplashGetAllData

        let url = shahrvandFlag ? typeExport._baseUrlSainaShahrvand : typeExport._baseUrlSainaShahrdar;
        let DateTime = new Date().getTime()

        let nameImage = DateTime + '.jpg';
        let nameVideo = DateTime + '.mp4';
        let nameAudio = DateTime + '.aac';

        const formData = new FormData();
        formData.append('_operation', shahrvandFlag ? typeExport._Contacts : typeExport._Shahrdar);
        formData.append('mode', shahrvandFlag ? "AddCommentUser" : "AddComment");
        formData.append('lang', i18n.locale);
        formData.append(shahrvandFlag ? 'token' : '_session', token);
        formData.append('record', params.record);
        formData.append('tracking_code', params.tracking_code ? params.tracking_code : null);
        ///let id= ((typeExport._NameApp === "Cloud"|| typeExport._NameApp === "CloudTest") )?item.tracking_code :item.id;
        // formData.append('record',id );

        formData.append('comment', params.comment);
        formData.append('durationVoice', params.durationVoice);

        if (params.audio && params.audio !== null) {
            if (Platform.OS === "web") {
                //  formData.append('audio', params.audio, nameAudio + ".aac");
                formData.append('audio', params.audioBlob, nameAudio);
                //const blobFile = new File([params.audio], nameAudio + ".aac");
                //formData.append("audio", params.audioBlob);
            }
            else
                formData.append('audio', {
                    uri: params.audio,
                    name: nameAudio,
                    type: 'audio/aac'
                });
        }


        // if (params.image && params.image !== null)
        //     if (Platform.OS === "web") {
        //         formData.append('image', params.image, nameImage);
        //
        //     }
        //     else {
        //         formData.append('image', {
        //             uri: params.image,
        //             name: nameImage,
        //             type: 'image/jpeg'
        //         });
        //     }

        if (params.video && params.video !== null) {
            if (Platform.OS === "web") {
                //  formData.append('audio', params.audio, nameAudio + ".aac");
                formData.append('video', params.video, nameVideo);
                //const blobFile = new File([params.audio], nameAudio + ".aac");
                //formData.append("audio", params.audioBlob);
            }
            else
                formData.append('video', {
                    uri: params.video,
                    name: nameVideo,
                    type: 'video/mp4'
                });
        }


        if (params.arrImage)
            for (let i = 0; i < params.arrImage.length; i++) {
                if (Platform.OS === "web") {
                    formData.append('image' + "_" + i, params.arrImage[i], nameImage);

                }
                else
                    formData.append('image' + "_" + i, {
                        uri: params.arrImage[i],
                        name: nameImage,
                        type: 'image/jpeg'
                    });
            }
        formData.append('platform', Platform.OS);

        const config = {
            headers: {
                "Content-Type": "multipart/form-data; charset=utf-8;",
                // 'Content-Type': 'application/json',
                //  "Authorization": `Basic ${params.token}`,
                timeout: params.video !== null ? typeExport._TIMEOUT_FILE : typeExport._TIMEOUT,
            }
        };
        axios.post(url, formData, config)
            .then(async response => {
                let data = response.data;
                if (response.data.success) {

                    //   funcSuccess ? funcSuccess(response.data.result.item) : null;
                    funcSuccess ? funcSuccess(response.data.result.lastWork) : null;

                    /*    HMAlert(
                            i18n.t('constant.message'),
                            "با موفقیت ثبت شد",
                            [
                                {
                                    text: i18n.t('constant.ok'), onPress: () => {

                                        //   NavigationService.navigatereset("ApplyScreen", {item: item ? item:getState.route.params.item})
                                    }


                                },
                                {
                                    // text: i18n.t('constant.NowNot'),
                                    // onPress: () => {
                                    // },
                                    // style: 'cancel'
                                },


                            ],
                            {cancelable: true}
                        )*/
                } else {
                    funcError ? funcError(response) : null;


                    alert(response.data.error && response.data.error.message ? response.data.error.message : i18n.t('constant.ServerEncounteredProblemTryingAgain'))
                }
            }).catch((e) => {
            console.log(e)
            funcError ? funcError(response) : null;

            alert("error")
        })
    }

    static requestAddCommentSatia(params, funcSuccess, funcError) {
        let {token} = store.getState().reducerSplashSatiaScreen

        let url = typeExport._baseUrlSatia + "operator_tk/createNewTaskResend";
        let DateTime = new Date().getTime()

        let nameImage = DateTime + '.jpg';
        let nameVideo = DateTime + '.mp4';
        let nameAudio = DateTime + '.aac';

        const formData = new FormData();

        formData.append('lang', i18n.locale);
        formData.append('token', token);

        formData.append('comment', params.comment);
        formData.append('durationVoice', params.durationVoice ? params.durationVoice : null);


        formData.append('title', params.title ? params.title : null);
        formData.append('taskRef', params.taskRef ? params.taskRef : null);
        formData.append('description', params.description ? params.description : null);
        formData.append('status', params.status ? params.status : null);
        formData.append('ccTo', params.ccTo ? params.ccTo : null);
        formData.append('referTo', params.referTo ? params.referTo : null);
        formData.append('taskType', params.taskType ? params.taskType : null);
        formData.append('platform', Platform.OS);


        if (params.audio && params.audio !== null) {
            if (Platform.OS === "web") {
                //  formData.append('audio', params.audio, nameAudio + ".aac");
                formData.append('audio', params.audioBlob, nameAudio);
                //const blobFile = new File([params.audio], nameAudio + ".aac");
                //formData.append("audio", params.audioBlob);
            }
            else
                formData.append('audio', {
                    uri: params.audio,
                    name: nameAudio,
                    type: 'audio/aac'
                });
        }


        // if (params.image && params.image !== null)
        //     if (Platform.OS === "web") {
        //         formData.append('image', params.image, nameImage);
        //
        //     }
        //     else {
        //         formData.append('image', {
        //             uri: params.image,
        //             name: nameImage,
        //             type: 'image/jpeg'
        //         });
        //     }

        if (params.video && params.video !== null) {
            if (Platform.OS === "web") {
                //  formData.append('audio', params.audio, nameAudio + ".aac");
                formData.append('video', params.video, nameVideo);
                //const blobFile = new File([params.audio], nameAudio + ".aac");
                //formData.append("audio", params.audioBlob);
            }
            else
                formData.append('video', {
                    uri: params.video,
                    name: nameVideo,
                    type: 'video/mp4'
                });
        }


        if (params.arrImage)
            for (let i = 0; i < params.arrImage.length; i++) {
                if (Platform.OS === "web") {
                    formData.append('image' + "_" + i, params.arrImage[i], nameImage);

                }
                else
                    formData.append('image' + "_" + i, {
                        uri: params.arrImage[i],
                        name: nameImage,
                        type: 'image/jpeg'
                    });
            }

        const config = {
            headers: {
                "Content-Type": "multipart/form-data; charset=utf-8;",
                // 'Content-Type': 'application/json',
                //  "Authorization": `Basic ${params.token}`,
                timeout: params.video !== null ? typeExport._TIMEOUT_FILE : typeExport._TIMEOUT,
            }
        };
        //   axios.post(url, formData, config)
        axios({
            method: 'post',
            url: url,
            data: formData,
            headers: {'Content-Type': 'multipart/form-data'},
            timeout: typeExport._TIMEOUT,

        })
            .then(async response => {
                let data = response.data;
                if (data.status) {

                    //   funcSuccess ? funcSuccess(response.data.result.item) : null;
                    funcSuccess ? funcSuccess(response.data, response) : null

                    /*    HMAlert(
                            i18n.t('constant.message'),
                            "با موفقیت ثبت شد",
                            [
                                {
                                    text: i18n.t('constant.ok'), onPress: () => {

                                        //   NavigationService.navigatereset("ApplyScreen", {item: item ? item:getState.route.params.item})
                                    }


                                },
                                {
                                    // text: i18n.t('constant.NowNot'),
                                    // onPress: () => {
                                    // },
                                    // style: 'cancel'
                                },


                            ],
                            {cancelable: true}
                        )*/
                }
                else {

                    funcError ? funcError() : null;
                    alert(data.message ? data.message : i18n.t('constant.ServerEncounteredProblemTryingAgain'))
                }
            }).catch((e) => {
            funcError ? funcError() : null;
            console.log(e)
            alert("error")
        })
    }
}
